// Language of generated reports (currently only DECLARATION is translated by the API).
// Kept per browser in localStorage; sent to the API as ?language=.

export const ReportLanguage = {
  SR: { value: "SR", label: "Srpski" },
  MK: { value: "MK", label: "Makedonski" },
  SQ: { value: "SQ", label: "Albanski" },
  EN: { value: "EN", label: "Engleski" },
};

const STORAGE_KEY = "reportLanguage";
const CHANGE_EVENT = "report-language-change";
const DEFAULT_LANGUAGE = ReportLanguage.SR.value;

// fallback when localStorage is unavailable (private mode, blocked storage)
let currentLanguage = DEFAULT_LANGUAGE;

export const getReportLanguage = () => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return ReportLanguage[value] ? value : currentLanguage;
  } catch (e) {
    return currentLanguage;
  }
};

export const setReportLanguage = (language) => {
  currentLanguage = language;
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch (e) {
    // storage unavailable; currentLanguage keeps the choice for this session
  }
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: language }));
};

export const onReportLanguageChange = (callback) => {
  const handleChange = (event) => callback(event.detail);
  window.addEventListener(CHANGE_EVENT, handleChange);
  return () => window.removeEventListener(CHANGE_EVENT, handleChange);
};
